"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeDecode = void 0;
function safeDecode(value) {
    if (!value)
        return '';
    try {
        return decodeURIComponent(value);
    }
    catch (_a) {
        return value;
    }
}
exports.safeDecode = safeDecode;
